import { ScreenerTransactionsParams } from "@api/token-screener/screener-transactions.ts";
import { useCallback, useState } from "react";
import {
  getDefaultFilters,
  TransactionHistoryFilterContext,
} from "@providers/token-history-filter/context.ts";

const TransactionHistoryFilterProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const [filters, setFilters] =
    useState<ScreenerTransactionsParams["filters"]>(getDefaultFilters());

  const onFilterUpdate = useCallback(
    (filters: ScreenerTransactionsParams["filters"]) => {
      setFilters(filters);
    },
    [],
  );

  return (
    <TransactionHistoryFilterContext.Provider
      value={{ filters, onFiltersUpdate: onFilterUpdate }}
    >
      {children}
    </TransactionHistoryFilterContext.Provider>
  );
};

export default TransactionHistoryFilterProvider;
